var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircledPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C20.627 2 26 7.373 26 14C26 20.627 20.627 26 14 26C7.373 26 2 20.627 2 14C2 7.373 7.373 2 14 2ZM14 3.5C8.201 3.5 3.5 8.201 3.5 14C3.5 19.799 8.201 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.201 19.799 3.5 14 3.5ZM14 8C14.1989 8 14.3897 8.07902 14.5303 8.21967C14.671 8.36032 14.75 8.55109 14.75 8.75V13.25H19.25C19.4489 13.25 19.6397 13.329 19.7803 13.4697C19.921 13.6103 20 13.8011 20 14C20 14.1989 19.921 14.3897 19.7803 14.5303C19.6397 14.671 19.4489 14.75 19.25 14.75H14.75V19.25C14.75 19.4489 14.671 19.6397 14.5303 19.7803C14.3897 19.921 14.1989 20 14 20C13.8011 20 13.6103 19.921 13.4697 19.7803C13.329 19.6397 13.25 19.4489 13.25 19.25V14.75H8.75C8.55109 14.75 8.36032 14.671 8.21967 14.5303C8.07902 14.3897 8 14.1989 8 14C8 13.8011 8.07902 13.6103 8.21967 13.4697C8.36032 13.329 8.55109 13.25 8.75 13.25H13.25V8.75C13.25 8.55109 13.329 8.36032 13.4697 8.21967C13.6103 8.07902 13.8011 8 14 8Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledPlus);
export default __webpack_public_path__ + "static/media/circled-plus.71fe2110189a1b12bafc28d2cd79e604.svg";
export { ForwardRef as ReactComponent };